export default __webpack_public_path__ + "static/media/home_basemap@2x.80c2cbfe.webp";